import { createContext, useContext } from "react";

import {
  EnrollmentFragment,
  GroupFragment,
  WorkOutcomeClassFragment,
} from "@/generated/graphql";
import { TagConfig } from "@/ui/StudentLists/TagSelector";

export type FeedbackReleaseStatus = {
  hasGroupFeedbackReleased: boolean;
  hasIndividualFeedbackReleased: boolean;
  hasFinalFeedbackReleased: boolean;
  hasProvisionalFeedbackReleased: boolean;
  finalIndividualWorkOutcomes: number;
  provisionalIndividualWorkOutcomes: number;
};

export interface ModerationContextState {
  /** Callback to download filtered moderation metrics. */
  onDownloadMetricsData?: () => void;
  /** Moderation ready enrollments (students with marked work outcomes) */
  enrollments: EnrollmentFragment[];
  /** Global tag configurations for all students (including unmarked) */
  globalTags: TagConfig[];
  /** Moderation ready groups */
  assessmentGroups: GroupFragment[];
  /** Moderation ready work outcomes */
  workOutcomes: WorkOutcomeClassFragment[];
  /** check if we are moderation ready or not */
  feedbackReleaseStatus: FeedbackReleaseStatus;
}

export const ModerationContext = createContext<ModerationContextState>({
  enrollments: [],
  globalTags: [],
  assessmentGroups: [],
  workOutcomes: [],
  feedbackReleaseStatus: {
    hasGroupFeedbackReleased: false,
    hasIndividualFeedbackReleased: false,
    hasFinalFeedbackReleased: false,
    hasProvisionalFeedbackReleased: false,
    finalIndividualWorkOutcomes: 0,
    provisionalIndividualWorkOutcomes: 0,
  },
});

export const useModerationContext = () => useContext(ModerationContext);

/**
 * Predicate hook to check if moderation should be readonly.
 */
export function useModerationIsReadOnly() {
  return useModerationContext().feedbackReleaseStatus.hasFinalFeedbackReleased;
}
